import styled from 'styled-components/macro'
import { loaderSpin } from 'utils/animations'

export const StyleLoader = styled.span<{ width: number; height: number; color?: string }>`
  display: block;
  width: ${(props) => props.width}rem;
  height: ${(props) => props.height}rem;
  color: ${(props) => props.color};
  overflow: hidden;
  transform-origin: center center;
  animation: ${loaderSpin} 4s steps(12, end) infinite;
`
